<template>
	<div class="relative">
		<!-- category stuff -->
		<div class="flex w-full justify-center pt-12 sm:py-12 px-3">
			<div class="w-full max-w-8xl">
				<div class="flex w-full my-auto pb-2">
					<ImageScroller class="" label="Popular Brands" :sideButtons="true" shopAll="/categories">
						<!-- <router-link
							v-for="(brand, i) in brands"
							:key="i"
							:to="`/categories${brand?.url?.path}`"
							class="relative overflow-hidden rounded-lg snap-start w-[calc((100%-1rem)/2)] sm:w-[calc((100%-2rem)/3)] lg:w-[calc((100%-3rem)/4)] shrink-0"
						>


							<img :src="brand.imageUrl" class="rounded-lg w-full h-full sm:min-h-60 md:min-h-96 md:max-h-fit object-center object-cover" />
							<div class="absolute inset-0 flex items-end justify-center bg-gradient-to-tr from-ihh-black/50 to-ihh-secondary-white/10">
								<div class="before-hover w-full">
									<div class="absolute inset-0 flex flex-col items-start justify-end text-white bottom-4 left-4 md:bottom-10 md:left-10 pr-4">
										<div class="text-2xl md:text-4xl tracking-wide font-semibold max-w-40 md:max-w-52">{{ brand.name }}</div>

										<div class="md:mt-4 cursor-pointer group border-3 border-ihh-secondary-white rounded-xl overflow-hidden">
											<button class="text-xs md:text-sm group-hover:bg-ihh-secondary-white px-4 py-2 md:px-8 md:py-3 transition ease-in-out">
												Shop now
											</button>
										</div>
									</div>
								</div>
							</div>
						</router-link> -->
						<router-link
							:to="`/categories${brand?.url?.path}`"
							v-for="brand in brands"
							:key="brand.id"
							class="flex flex-col snap-start w-[calc((100%-1rem)/2)] sm:w-[calc((100%-2rem)/3)] md:w-[calc((100%-3rem)/4)] lg:w-[calc((100%-4rem)/5)] shrink-0 group"
						>
							<div class="relative overflow-hidden rounded-lg w-full aspect-square">
								<div class="absolute inset-0 bg-center bg-cover" :style="`background-image: url(${brand.imageUrl})`" />
								<div class="absolute inset-0 bg-gradient-to-t from-ihh-black/30 to-ihh-black/10 group-hover:opacity-75 transition-all" />
							</div>
							<div class="w-full text-center mt-2">
								<div class="text-base md:text-xl font-semibold tracking-wide">
									{{ brand.name }}
								</div>
							</div>
						</router-link>
					</ImageScroller>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ImageScroller from './image-scroller.vue'
import Mango from '../../../helpers/mango'

// These popular categories are using images that aren't on the category as it's synced from Big Commerce
// Hard coded the categories for now

export default {
	components: { ImageScroller },
	inject: ['store'],
	data() {
		return {
			popularBcIds: [
				20, // Dopplers
				51, // Sitz Baths
				142, // Birth Pool in a Box
				181, // Wishgarden Herbs
				108, // Earth Mama
				18, // Education
				105, // Oasis Birth Pools
				55, // Teas
			],
			categories: [
				{
					title: 'Dopplers',
					image: '/images/4v3-dopplers-0129.jpg',
					description: 'Everything you need for a water birth',
					path: '/categories/dopplers-and-accessories/',
				},
				{
					title: 'Sitz Baths',
					image: '/images/herbal-afterbirth-0129.jpg',
					description: 'Top quality natural products',
					path: '/categories/after-birth-baths-and-herbal-powders/',
				},
				{
					title: 'Birth Pool in a Box',
					image: '/images/5v3-0129.jpg',
					description: 'Pregnancy & postpartum essentials',
					path: '/categories/BPIAB',
				},
				{
					title: 'Wishgarden Herbs',
					image: '/images/8v3-0129.jpg',
					description: 'Pregnancy & postpartum essentials',
					path: '/categories/wishgarden-herbal-tinctures/',
				},
				{
					title: 'Earth Mama',
					image: '/images/earth-mama.png',
					description: 'Natural care for mothers and babies',
					path: '/categories/earth-mama/',
				},
				{
					title: 'Education',
					image: '/images/education.png',
					description: 'Resources for learning and growth',
					path: '/categories/education/',
				},
				{
					title: 'Oasis Birth Pools',
					image: '/images/oasis-birth-pools.png',
					description: 'Comfortable birth pools for home birth',
					path: '/categories/oasis-pools/',
				},
				{
					title: 'Teas',
					image: '/images/teas.png',
					description: 'Relaxing and nourishing herbal teas',
					path: 'categories/after-birth-baths-and-herbal-powders/',
				},
			],
			brands: [],
			brandIds: [
				180, // Earth Mama
				171, // Birth Pool in a Box
				181, // Wishgarden Herbs
				173, // Masimo
				182, // Earthside Birth Pools
				184, // Earthly
				183, // Prestige Medical
				135, // Frida Mom
			],
		}
	},

	async mounted() {
		this.brands = await Mango.categories({
			search: {
				bcId: { $in: this.brandIds },
			},
			fields: ['name', 'url', 'imageUrl', 'bcId'],
			limit: 50,
		})
		console.log(this.brands)
	},
}
</script>
